import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TimeColumn, { DAY_HEADER_HEIGHT } from './TimeColumn'
import DayColumn from './DayColumn'
import { isSameDay } from './utils'

export default function WeekGrid({ days, events, hourStart, hourEnd }) {
  const [now, setNow] = useState(new Date())

  // Update current time every minute for the red time indicator
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000)
    return () => clearInterval(timer)
  }, [])

  if (events.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6, color: 'text.secondary' }}>
        <Typography>No lessons scheduled this week</Typography>
      </Box>
    )
  }

  const totalHours = hourEnd - hourStart
  const showTimeLine = days.some(d => isSameDay(d, now))
  const timeLineTop = showTimeLine
    ? (now.getHours() - hourStart) * 60 + now.getMinutes()
    : -1

  return (
    <Box sx={{ display: 'flex', position: 'relative', pb: 3 }}>
      {/* Time column */}
      <TimeColumn hourStart={hourStart} hourEnd={hourEnd} />

      {/* Day columns */}
      <Box sx={{ display: 'flex', flex: 1, position: 'relative' }}>
        {days.map(day => (
          <DayColumn
            key={day.toISOString()}
            day={day}
            events={events}
            hourStart={hourStart}
            hourEnd={hourEnd}
          />
        ))}

        {/* Current time red line */}
        {showTimeLine && timeLineTop >= 0 && timeLineTop <= totalHours * 60 && (
          <Box
            sx={{
              position: 'absolute',
              top: `${DAY_HEADER_HEIGHT + timeLineTop}px`,
              left: 0,
              right: 0,
              height: '2px',
              bgcolor: 'error.main',
              zIndex: 2,
              pointerEvents: 'none',
              '&::before': {
                content: '""',
                position: 'absolute',
                left: -4,
                top: -3,
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: 'error.main',
              },
            }}
          />
        )}
      </Box>
    </Box>
  )
}
